import { ActionTypes } from "../constants/actionTypes";
import { apiService } from "../../services/apiServices";

export const createSpecialDeliveryOrder = (
  requestObject,
  authParams,
  history,
  handleError,
) => {
  return async (dispatch) => {
    dispatch({ type: ActionTypes.SET_LOADER });

    try {
      const response = await apiService.createSpecialDelivery(
        requestObject,
        authParams,
      );

      dispatch({
        type: ActionTypes.SPECIAL_DELIVERY_INTAKE_SUCCESS,
        payload: response?.data,
      });

      return response?.data;
    } catch ({ response = {} }) {
      const { data = "Network Error!", status } = response;

      dispatch({
        type: ActionTypes.SPECIAL_DELIVERY_INTAKE_FAILURE,
        payload: data,
      });

      if (status === 401) return history("/unauthorized");
      handleError({ data });
    } finally {
      dispatch({ type: ActionTypes.UNSET_LOADER });
    }
  };
};

export const assignSpecialDeliveryTour = (
  requestObject,
  authParams,
  history,
  handleError,
) => {
  return async (dispatch) => {
    dispatch({ type: ActionTypes.SET_LOADER });

    try {
      const response = await apiService.assignSpecialDelivery(
        requestObject,
        authParams,
      );

      dispatch({
        type: ActionTypes.SPECIAL_DELIVERY_ASSIGN_SUCCESS,
        payload: response?.data,
      });

      return response?.data;
    } catch ({ response = {} }) {
      const { data = "Network Error!", status } = response;

      dispatch({
        type: ActionTypes.SPECIAL_DELIVERY_ASSIGN_FAILURE,
        payload: data,
      });

      if (status === 401) return history("/unauthorized");
      handleError({ data });
    } finally {
      dispatch({ type: ActionTypes.UNSET_LOADER });
    }
  };
};
